import { RefObject, useEffect, useContext } from 'react';
import SessionContext from 'src/contexts/SessionContext';
import { useIntersectionObserver, useReadMessage } from 'src/hooks';

export const useReadMessageByScrolling = ({
  anchorRef,
  taskId,
  isTaskRequiresAttention,
}: {
  anchorRef: RefObject<HTMLDivElement>;
  taskId: string;
  isTaskRequiresAttention: boolean;
}) => {
  const { readMessage } = useReadMessage();
  const { currentScrollingTaskId, setCurrentScrollingTaskId } =
    useContext(SessionContext);

  const isVisible = useIntersectionObserver(anchorRef, { threshold: 1.0 });

  useEffect(() => {
    if (!isTaskRequiresAttention || !isVisible) {
      return;
    }

    if (!!currentScrollingTaskId && currentScrollingTaskId === taskId) {
      setCurrentScrollingTaskId(null);
      return;
    }

    if (!currentScrollingTaskId) {
      readMessage(taskId);
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible, isTaskRequiresAttention, taskId, currentScrollingTaskId]);

  return { isTaskRequiresAttention };
};
